import { memo } from 'react';

import {
    TablePagination,
    TablePaginationProps,
} from '@speeki/global-ui-components';

import {
    EmptyList,
    EmptyListProps,
} from '@components/atoms/EmptyList/EmptyList';
import { EmptySearchList } from '@components/atoms/EmptySearchList/EmptySearchList';
import {
    ColumnDefinitionType,
    ListTable,
} from '@components/molecules/ListTable/ListTable';

import { SkeletonList } from './List.styled';

interface ListProps<T extends { id: string }> {
    columns: ColumnDefinitionType<T>[];
    emptyListProps: EmptyListProps;
    isLoading: boolean;
    isSearch: boolean;
    list?: T[];
    onRowClick: (id: string) => void;
    pagination: TablePaginationProps;
    testId: string;
}

const ListComponent = <T extends { id: string }>({
    columns,
    emptyListProps,
    isLoading,
    isSearch,
    list,
    onRowClick,
    pagination,
    testId,
}: ListProps<T>) => {
    if (isLoading)
        return <SkeletonList count={10} height={70} width={'100%'} />;

    if (!list?.length)
        return isSearch ? (
            <EmptySearchList />
        ) : (
            <EmptyList {...emptyListProps} />
        );

    return (
        <div>
            <ListTable
                columnsConfig={columns}
                data={list}
                onRowClick={onRowClick}
                testId={testId}
            />
            <TablePagination {...pagination} />
        </div>
    );
};

export const List = memo(ListComponent) as typeof ListComponent;
